
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/tantrums-self-will",
      function () {
        return require("private-next-pages/blog/tantrums-self-will.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/tantrums-self-will"])
      });
    }
  